import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { GameResponseKeys } from './../../../../api/Constants';
import { getGameRooms } from '../';
import { setNewGames, setFeaturedGames, setSlotGames, setTableGames, setVipGames, setSportsGames } from '../../../actions/game';
import { showVipAccessModal, setVipRoomUnlocked, setUnlimitedVipAccess } from '../../../slices/consumables/consumables';
import Logger from '../../../../lib/analytics/logger';
import { EVENT_TYPES } from '../../../../lib/analytics/constants';
import ERROR_CODE from '../../../../utils/errorCodes';
import store from '../../../../state/store';
import transformObjectArrayResponse from '../../../../utils/transformObjectArrayResponse';
import transformObjectResponseKeys from '../../../../utils/transformObjectResponseKeys';
export var GAME_ROOMS = {
  SLOTS: 'slots',
  TABLE: 'table',
  CONFIGURABLE_VIP: 'configurable_vip',
  SPORTS: 'sports'
};
var ROOMS_KEYS = [GAME_ROOMS.SLOTS, GAME_ROOMS.TABLE, GAME_ROOMS.CONFIGURABLE_VIP];
var GAME_ROOMS_SET = {
  new_games: setNewGames,
  featured: setFeaturedGames,
  slots: setSlotGames,
  table: setTableGames,
  sports: setSportsGames,
  configurable_vip: setVipGames
};

var transformGameRoom = function transformGameRoom(gameRoom) {
  return _objectSpread(_objectSpread({}, gameRoom), {}, {
    gameRoomBalanceThreshold: _objectSpread(_objectSpread({}, gameRoom.gameRoomBalanceThreshold), {}, {
      amount: parseInt(gameRoom.gameRoomBalanceThreshold.amount || 0)
    }),
    news: transformObjectArrayResponse(gameRoom.news),
    games: transformObjectArrayResponse(gameRoom.games).map(function (game) {
      return transformObjectResponseKeys(game, GameResponseKeys);
    })
  });
};

var handleSportsRoom = function handleSportsRoom(response) {
  var sports;
  ROOMS_KEYS.forEach(function (roomKey) {
    var roomIndex = response[roomKey].findIndex(function (room) {
      return room.roomName === 'Sports';
    });

    if (roomIndex !== -1) {
      sports = response[roomKey][roomIndex];
      sports = _objectSpread(_objectSpread({}, sports), {}, {
        source: roomKey
      });
      response[roomKey].splice(roomIndex, 1);
    }
  });
  if (sports) response.sports = [sports];
  return response;
};

export var getGameRoomResponseHandler = function getGameRoomResponseHandler(gamelist) {
  var response = _objectSpread({}, gamelist);

  Object.keys(response).forEach(function (key) {
    response[key] = transformObjectArrayResponse(response[key]).map(function (item) {
      return ROOMS_KEYS.includes(key) ? transformGameRoom(item) : transformObjectResponseKeys(item, GameResponseKeys);
    });
  });
  return handleSportsRoom(response);
};
export var updateGameRooms = function updateGameRooms(gamesList, dispatch) {
  Object.keys(GAME_ROOMS_SET).forEach(function (key) {
    var gameRoom = gamesList[key];

    if (gameRoom) {
      dispatch(GAME_ROOMS_SET[key](gameRoom));

      if (key === 'configurable_vip') {
        dispatch(showVipAccessModal(true));
        dispatch(setVipRoomUnlocked(gameRoom[0].can_enter_room));
        dispatch(setUnlimitedVipAccess(gameRoom[0].unlimited_access || false));
      }
    }
  });
};
export var fetchGameRooms = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var forceRefetch,
        pollingInterval,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            forceRefetch = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            pollingInterval = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            _context.prev = 2;
            _context.next = 5;
            return store.dispatch(getGameRooms.initiate('fetchGameRooms', _objectSpread({
              forceRefetch: forceRefetch
            }, pollingInterval && {
              subscriptionOptions: {
                pollingInterval: 120000
              }
            }))).unwrap();

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
              code: ERROR_CODE.LOBBY_OVERLAY_FETCH_GAME_ROOMS_FAIL
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));

  return function fetchGameRooms() {
    return _ref.apply(this, arguments);
  };
}();